import { __extends } from "tslib";
import { getShadowElement } from '@tyler-components-web/core';
import { BaseAdapter } from '../core/adapters/base-adapter';
import { PROGRESS_SPINNER_CONSTANTS } from './progress-spinner-constants';
/**
 * Provides facilities for interacting with the internal DOM of `ProgressSpinnerComponent`.
 */
var ProgressSpinnerAdapter = /** @class */ (function (_super) {
    __extends(ProgressSpinnerAdapter, _super);
    function ProgressSpinnerAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._animationStyleElement = getShadowElement(component, PROGRESS_SPINNER_CONSTANTS.selectors.ANIMATION_STYLE_CONTAINER);
        _this._containerElement = getShadowElement(component, PROGRESS_SPINNER_CONSTANTS.selectors.CONTAINER);
        _this._svgElement = getShadowElement(component, 'svg');
        _this._circleElement = getShadowElement(component, 'svg > circle');
        return _this;
    }
    ProgressSpinnerAdapter.prototype.setAnimationStyle = function (content) {
        this._animationStyleElement.textContent = content;
    };
    ProgressSpinnerAdapter.prototype.setContainerSize = function (size) {
        this._containerElement.style.height = size + "px";
        this._containerElement.style.width = size + "px";
    };
    ProgressSpinnerAdapter.prototype.setSvgSize = function (size) {
        this._svgElement.style.height = size + "px";
        this._svgElement.style.width = size + "px";
    };
    ProgressSpinnerAdapter.prototype.setSvgViewBox = function (value) {
        this._svgElement.setAttribute('viewBox', value);
    };
    ProgressSpinnerAdapter.prototype.setCircleRadius = function (radius) {
        this._circleElement.setAttribute('r', radius.toString());
    };
    ProgressSpinnerAdapter.prototype.setCircleStyle = function (styles) {
        var _this = this;
        Object.keys(styles).forEach(function (key) {
            _this._circleElement.style[key] = styles[key];
        });
    };
    ProgressSpinnerAdapter.prototype.setAnimationClass = function (name) {
        this._containerElement.classList.add(name);
    };
    ProgressSpinnerAdapter.prototype.setContainerAttribute = function (name, value) {
        this._containerElement.setAttribute(name, value);
    };
    return ProgressSpinnerAdapter;
}(BaseAdapter));
export { ProgressSpinnerAdapter };
